module.exports = __webpack_public_path__ + "media/images/flags/32/Sao-Tome-and-Principe-2660fb4ac3d3989f2512c1b311d84676.png";